import {
  ContextMenuShowingEventArgs,
  CustomCommandExecutedEventArgs,
  RibbonTabType,
  RichEdit,
} from 'devexpress-richedit';

type BaseUiItem = {
  id: string;
  text: string;
  icon?: string;
  type: 'button' | 'dropdown' | 'contextmenu';
  action: (richEdit: RichEdit, args: CustomCommandExecutedEventArgs) => void;
};

type SubItem = Omit<BaseUiItem, 'type' | 'action'>;

export type CustomDropDownInnerProps = Omit<DropDownUiItem, 'type' | 'tab'>;

export type CustomContextMenuInnerProps = Omit<ContextMenuUiItem, 'type'>;

export type BaseRibbonItem = BaseUiItem & {
  showText?: boolean;
  insertIndex?: number;
  tab: RibbonTabType;
};

export type ButtonUiItem = BaseRibbonItem & {
  type: 'button';
  toggleMode?: boolean;
  enabled: boolean;
};

export type DropDownUiItem = BaseRibbonItem & {
  type: 'dropdown';
  items: SubItem[];
  enabled: boolean;
};

export type ContextMenuUiItem = BaseUiItem & {
  type: 'contextmenu';
  beginGroup?: boolean;
  insertIndex?: number;
  onContextMenuShowing: (
    richEdit: RichEdit,
    args: ContextMenuShowingEventArgs,
  ) => void;
};

export const isRibbonItem = (item: BaseUiItem): item is BaseRibbonItem =>
  'tab' in item;

export const isButtonItem = (item: BaseUiItem): item is ButtonUiItem =>
  item.type === 'button';

export const isDropDownItem = (item: BaseUiItem): item is DropDownUiItem =>
  item.type === 'dropdown';

export const isContextMenuItem = (
  item: BaseUiItem,
): item is ContextMenuUiItem => item.type === 'contextmenu';

export type UiItemConfig = ButtonUiItem | DropDownUiItem | ContextMenuUiItem;
